import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import ConversationHomepage from "../../../components/common/Communication/ConversationHomepage";
import MessageWrapper from "../../../components/common/Communication/MessageWrapper";
import { useGetOneToOneChatListQuery } from "../../../features/superAdmin/ticketService/ticketServiceApi";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function Message() {
  const [search, setSearch] = useState("");
  const [searchParams] = useSearchParams();
  const leave = searchParams.get("leave");
  const [type, setType] = useState("");

  const auth = useAppSelector((state) => state.auth);
  const {
    data: oneToOneChatListData,
    isLoading,
    refetch,
  } = useGetOneToOneChatListQuery(
    {
      params: {
        id: auth.user?.id || "",
        search: search,
        type: type,
      },
    },
    { skip: !auth.user?.id },
  );

  useEffect(() => {
    if (leave === "true") {
      try {
        refetch();
      } catch (err) {}
    }
  }, [leave, refetch]);

  return (
    <SidebarLayout title="Communication">
      <MessageWrapper
        isLoading={isLoading}
        oneToOneChatListData={oneToOneChatListData}
        setSearch={setSearch}
        setType={setType}
        type={type}
      >
        <ConversationHomepage />
      </MessageWrapper>
    </SidebarLayout>
  );
}
